import { useAddRemoveQuery } from "@website/hooks/add-remove-query";
import Baloon from "@website/icons/components/baloon";
import Hotel from "@website/icons/components/hotel";
import HotelInternational from "@website/icons/components/hotel-international";
import VentureBus from "@website/icons/components/venture-bus";
import VentureFlight from "@website/icons/components/venture-flight";
import VentureFlightInt from "@website/icons/components/venture-flight-int";
import VentureTrain from "@website/icons/components/venture-train";
import Villa from "@website/icons/components/villa";
import { getChannel } from "@website/utils/channel/get-channel";
import { getIsLogin } from "@website/widget/is-login";
import { openLoginModal } from "@website/widget/login/use-login-modal";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";

const products: Record<string, string> = {
  "/": "DH",
  "/train": "Train",
  "/inter-flights": "IF",
  "/flights": "DF",
  "/villa": "Villa",
  "/bus": "Bus",
  "/bus-international": "IB",
  "/profile": "Profile",
  "/tour": "Tour"
};

export const usePurchaseMenu = () => {
  const router = useRouter();
  const key = "PURCHASE";
  const { [key]: isKey } = router.query;
  const { addQuery, removeQuery } = useAddRemoveQuery(key);
  const channel = getChannel();

  const onPurchaseMenuOpen = useCallback(() => {
    window?.webengage?.track("mytrips-clicked", {
      source: process.env.NEXT_PUBLIC_APP_NAME
    });
    addQuery("open");
  }, [addQuery]);

  const onPurchaseMenuClose = useCallback(() => {
    removeQuery();
  }, [removeQuery]);

  const purchaseList = useMemo(() => {
    const onClickHandler = (selectedService: string, event: string) => {
      window?.webengage?.track(event, {
        source: process.env.NEXT_PUBLIC_APP_NAME
      });
      const query = {
        ...omit(router.query, [key]),
        my_trips_tab: "0",
        selected_service: selectedService,
        source: String(process.env.NEXT_PUBLIC_APP_NAME),
        product: products[router?.pathname] || ""
      };
      const queryString = new URLSearchParams(query).toString();
      // window.location.href = `https://pwa.snapptrip.com/profile/my-trips?${
      //   queryString ?? ""
      // }`;

      // eslint-disable-next-line no-console
      console.log("q", query, queryString);
      const profileUrl = `/profile/my-trips${
        queryString ? `?${queryString}` : ""
      }`;

      if (getIsLogin()) {
        window.location.href = profileUrl;
      } else {
        openLoginModal(router).then(() => {
          window.location.href = profileUrl;
        });
      }
    };

    const list = [
      {
        type: "button",
        title: "هتل داخلی",
        icon: <Hotel />,
        onClick: () => onClickHandler("HOTEL", "DH-mytrips-clicked")
      },
      {
        type: "button",
        title: "هتل خارجی",
        icon: <HotelInternational />,
        onClick: () => onClickHandler("INTER_HOTEL", "IH-mytrips-clicked")
      },
      {
        type: "button",
        onClick: () => onClickHandler("FLIGHT", "DF-mytrips-clicked"),
        title: "پرواز داخلی",
        icon: <VentureFlight />
      },
      {
        type: "button",
        title: "پرواز خارجی",
        icon: <VentureFlightInt />,
        onClick: () => onClickHandler("INTER_FLIGHT", "IF-mytrips-clicked")
      },
      {
        type: "button",
        onClick: () => onClickHandler("BUS", "Bus-mytrips-clicked"),
        title: "اتوبوس",
        icon: <VentureBus />
      },
      {
        type: "button",
        title: "قطار",
        icon: <VentureTrain />,
        onClick: () => onClickHandler("TRAIN", "Train-mytrips-clicked")
      },
      {
        type: "button",
        title: "ویلا",
        icon: <Villa />,
        onClick: () => onClickHandler("VILLA", "Villa-mytrips-clicked")
      },
      {
        type: "button",
        title: "تور",
        icon: <Baloon />,
        onClick: () => onClickHandler("TOUR", "Tour-mytrips-clicked")
      }
    ];
    return list;
  }, [router, channel]);

  return {
    purchaseList,
    onPurchaseMenuOpen,
    onPurchaseMenuClose,
    purchaseMenuIsOpen: Boolean(isKey)
  };
};
